import React from 'react'

function EmptyIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={30}
      height={30}
      fill="none"
      {...props}
    >
      <circle cx={13} cy={13} r={13} fill="#78787B" />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth={1.5}
        d="M6.958 8.624a3.333 3.333 0 0 1 3.334-3.333h4.629c.236 0 .46.1.619.276l3.288 3.653a.833.833 0 0 1 .214.557v7.597a3.333 3.333 0 0 1-3.334 3.334h-5.416a3.333 3.333 0 0 1-3.334-3.334v-8.75Z"
      />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth={1.5}
        d="M14.042 5.291v1.667a3.333 3.333 0 0 0 3.333 3.333h1.667M10.917 16.958 13 14.874m0 0 2.083-2.083M13 14.874l-2.083-2.083M13 14.874l2.083 2.084"
      />
    </svg>
  )
}
export default EmptyIcon
